import * as React from 'react';
import { SVGProps } from 'react';

const SvgMentalHealth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M25.423 15.777a2.134 2.134 0 0 0-2.608-2.37 2.134 2.134 0 0 0-2.068-1.619c-.999 0-1.914.753-2.095 1.75a2.134 2.134 0 0 0-2.527 3.298h-.04s-.022-.004-.035-.004a.13.13 0 0 0-.034.003h-.025a1.068 1.068 0 0 0-1.01 1.066c0 .571.448 1.03 1.01 1.061v.007h6.062c.587 0 1.065-.475 1.065-1.065h2.236c.59 0 1.069-.478 1.069-1.069 0-.59-.44-1.024-1-1.058Z"
    />
    <path
      fill="currentColor"
      d="M18.061 30.628h1.559v-4.744l-.61-.138a7.728 7.728 0 0 1-6.043-7.577c0-4.285 3.486-7.77 7.771-7.77s7.77 3.485 7.77 7.77v.137l1.728 4.785h-2.033V25.5c0 .625-.244 1.215-.688 1.659a2.322 2.322 0 0 1-1.655.684h-1.152v2.786h1.524l.037.037v-1.283a3.861 3.861 0 0 0 2.349-1.122 3.882 3.882 0 0 0 1.146-2.76v-.847h1.359a.935.935 0 0 0 .88-1.255l-1.939-5.37c-.075-5.081-4.232-9.191-9.33-9.191-5.096 0-9.331 4.185-9.331 9.332a9.28 9.28 0 0 0 6.649 8.942M10.523 7.538 9.417 8.64l1.655 1.658 1.105-1.103-1.654-1.658Zm-2.617 3.608L7.5 12.654l2.262.609.406-1.508-2.262-.609Zm6.621-5.521-1.507.406.609 2.262 1.508-.406-.61-2.262Z"
    />
    <path
      fill={props.fill}
      d="M29.364 33.751H18.061v-3.123h8.174l3.13 3.123Z"
    />
  </svg>
);

export default SvgMentalHealth;
